import { BaseService } from "./BaseService";
import axios from 'axios';

const ROOT_URL = "https://todis.transport-community.org/api/";
//const ROOT_URL = "http://localhost:8080/api/";

export class AuthService extends BaseService {

    constructor(url) {

        super(url);
        
    }

    async signIn(params) {
        return this.create(params)
    }

    async changePassword(username, password) {
        try {
            const response = await axios.post(ROOT_URL + `auth/changePassword`, { username, password });
            return response.data;
        } catch (error) {
            throw new Error('Failed to change password');
        }
    }

}
export default AuthService;